import { FormFieldModel } from '../../PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { SeriesFilterTypesEnum } from '../enums/series-filter-types.enum';
import { mentionSeriesTypes, SeriesTypeEnum, socialSeriesTypes } from '../enums/series-type.enum';

export class SeriesPickerFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    multiSeries: boolean;
    maxNumberOfSeries: number;
    typeOptions: SeriesTypeEnum[];
    filters: SeriesFilterTypesEnum[];
    tooltipMessage: string[];
    showColorSwatch: boolean;
    isBarChart: boolean;
    required: boolean;
    headingId?: string;
    appearCondition?: (x: any) => boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        multiSeries?: boolean,
        maxNumberOfSeries?: number,
        typeOptions: SeriesTypeEnum[] = [...mentionSeriesTypes, ...socialSeriesTypes],
        filters: SeriesFilterTypesEnum[] = [
            SeriesFilterTypesEnum.keywords,
            SeriesFilterTypesEnum.authors,
            SeriesFilterTypesEnum.outlets,
            SeriesFilterTypesEnum.audience,
            SeriesFilterTypesEnum.ave,
            SeriesFilterTypesEnum.sentiment,
            SeriesFilterTypesEnum.mediaTypes,
            SeriesFilterTypesEnum.country,
            SeriesFilterTypesEnum.province,
            SeriesFilterTypesEnum.regions,
            SeriesFilterTypesEnum.languages,
            SeriesFilterTypesEnum.duplicates,
            SeriesFilterTypesEnum.aiAgents,
            SeriesFilterTypesEnum.tags,
            SeriesFilterTypesEnum.tagGroups,
            SeriesFilterTypesEnum.sourceGroups
        ],
        tooltipMessage?: string[],
        showColorSwatch: boolean = false,
        isBarChart: boolean = false,
        required: boolean = false,
        headingId?: string,
        appearCondition?: (x: any) => boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.multiSeries = multiSeries;
        this.maxNumberOfSeries = maxNumberOfSeries;
        this.typeOptions = typeOptions;
        this.filters = filters;
        this.tooltipMessage = tooltipMessage;
        this.showColorSwatch = showColorSwatch;
        this.isBarChart = isBarChart;
        this.required = required;
        this.headingId = headingId;
        this.appearCondition = appearCondition;
    }
}

